module.exports = __webpack_public_path__ + "static/media/security-2168233_640.45197f0a.jpg";